<template>
  <div class="p-6 bg-gray-100 min-h-screen flex flex-col items-center justify-center pb-40">
    <div class="max-w-md w-full">
 


      <!-- Imagen por defecto -->
      <div class="flex justify-center items-center">
        <img src="@/assets/logohp.png" alt="HP Logo" class="w-64 h-auto" />
      </div>
    </div>
  </div>
</template>

<script>


export default {

};
</script>

<style scoped>
/* Puedes añadir estilos personalizados si es necesario */
img {
  border-radius: 10px;
}
</style>
